import { AuthenticationContext } from 'react-adal';

export const adalConfig = {
    tenant: '72f988bf-86f1-41af-91ab-2d7cd011db47',
    clientId: 'e33c1b5a-49b8-4ca8-a16e-fc55a07b1d67',
    cacheLocation: 'sessionStorage',
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: false
};

export const authContext = new AuthenticationContext(adalConfig);